module.exports = __webpack_public_path__ + "static/img/qrcode-mobile.ddf7a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/content/images/qrcode-mobile.jpg
// module id = vzq/
// module chunks = 11